import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { appConfig } from '../../../environments/environment';
import * as debug from '../services/debug.service';

const DB_NAME = '1fd5411a9858492a84dcc9423d1b2638';

@Injectable({ providedIn: 'root' })
export class PersistentDbService extends Dexie {
	recommendedLogin: Dexie.Table<IRecommendedLogin, number>;

	constructor() {
		super(DB_NAME);
		this.version(1).stores({
			recommendedLogin: '++id'
		});
	}

	async clearAll(): Promise<void> {
		return await Dexie.delete(DB_NAME);
	}

	async store(data: string): Promise<string> {
		const newItem: IRecommendedLogin = { data };
		const saved = await this.recommendedLogin.put(newItem);

		return Promise.resolve(saved.toString());
	}

	async getRow(): Promise<string> {
		const row = await this.recommendedLogin.orderBy('id').last();
		if (!!row) {
			return Promise.resolve(row.data);
		}
		return Promise.resolve('');
	}
}

export interface IRecommendedLogin {
	id?: number;
	data: string;
}
